.tooltip {
  max-width: 360px;
  white-space: unset;
}